import { render, staticRenderFns } from "./SubmitOtherDialog.vue?vue&type=template&id=af3317dc&scoped=true"
import script from "./SubmitOtherDialog.vue?vue&type=script&lang=js"
export * from "./SubmitOtherDialog.vue?vue&type=script&lang=js"
import style0 from "./SubmitOtherDialog.vue?vue&type=style&index=0&id=af3317dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3317dc",
  null
  
)

export default component.exports